// Next Train Boston: store links and the shared navigation bar of its pages.
// The app is not in the stores yet. When it is, put the listing URLs here; every page reads them.
import React from 'react';

export const APP_STORE_URL = null;     // e.g. 'https://apps.apple.com/us/app/next-train-boston/id...'
export const GOOGLE_PLAY_URL = null;   // e.g. 'https://play.google.com/store/apps/details?id=com.n2o.nexttrain.boston'

export const NAME = 'Next Train Boston';
export const TAGLINE = 'Commuter rail and ferry times, offline';
export const ICON = '/next_train_boston_icon.png';

const YEAR = new Date().getFullYear();

/** App Store and Google Play badges; until a link exists the badge is shown dimmed as "coming soon". */
export function StoreBadges() {
    const badge = (url, src, alt) => url
        ? <a href={url} target="_blank" rel="noopener noreferrer">
            <img src={src} alt={alt} height="36" hspace="5" vspace="5"/>
        </a>
        : <span title="Coming soon">
            <img src={src} alt={alt + ' (coming soon)'} height="36" hspace="5" vspace="5" style={{opacity: 0.45}}/>
        </span>;
    return <>
        {badge(APP_STORE_URL, '/app_store.png', 'app store')}
        {badge(GOOGLE_PLAY_URL, '/google_play.svg', 'google play')}
    </>;
}

/** The bar at the top and bottom of every Next Train Boston page; `selected` names the current one. */
export function NextTrainBostonNav({navigate, selected, withProducts}) {
    const item = (target, hash, label) =>
        <li className={selected === target ? 'selected' : undefined}>
            <a href={hash} role="button" onClick={() => navigate(target)}>{label}</a>
        </li>;
    return <div className="fast_nav container">
        <ul>
            <li className="first">
                {withProducts
                    ? `${YEAR} © AnswerSolutions LLC`
                    : <a href="#" role="button" onClick={() => navigate('Products')}>{YEAR} © AnswerSolutions LLC</a>}
            </li>
            {withProducts && item('Products', '#Products', 'Products')}
            {item('NextTrainBostonProduct', '#next-train-boston-product', NAME)}
            {item('NextTrainBostonPolicy', '#nexttrainbostonpolicy', 'Privacy Policy')}
            {item('NextTrainBostonEULA', '#nexttrainbostoneula', 'User Agreement')}
            {item('NextTrainBostonSupport', '#nexttrainbostonsupport', 'Support')}
        </ul>
    </div>;
}

/** Icon, name and tagline, as at the top of the other product pages. */
export function NextTrainBostonHeader() {
    return <div>
        <img style={{borderRadius: '10%'}} className="roundrect" src={ICON} align="left"
             hspace="10" vspace="10" alt="app icon" width="128"/>
        <br/>
        <h2>{NAME}</h2>
        <h3>{TAGLINE}</h3>
    </div>;
}
